export const PLACEHOLDER_TEXT = 'Please enter the';
